import { Alert } from "reactstrap";

function FetchErrorIndicator() {
	return (
		<Alert color="danger">
			<div className="alert-body">
				<span className="ms-100 f-16 fw-600">
					مشکلی در ارتباط با سرور ایجاد شد لطفا با تیم پشتیبانی تماس بگیرید.
				</span>
			</div>
		</Alert>
	);
}

export default FetchErrorIndicator;
